import cx from "classnames";

import React, { CSSProperties } from "react";
import style from "./entity-form.module.scss";
import styles from "./entity-form.module.scss";

interface IEntityForm {
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
  title?: React.ReactNode;
  primaryAction?: React.ReactNode;
  extraActions?: React.ReactNode;
  footerNote?: React.ReactNode;
  secondaryAction?: React.ReactNode;
  destructiveAction?: React.ReactNode;
  children?: React.ReactNode;
  disabled?: boolean;
}

export const EntityForm = (props: IEntityForm) => {
  const footerStyle = props.primaryAction && props.primaryAction && props.secondaryAction;

  const hasActions = props.primaryAction || props.primaryAction || props.secondaryAction;

  return (
    <div
      className={cx(styles.entity_form, "entity-form", props.disabled && styles.disabled, props.className)}
      style={props.style}
      id={props.htmlId}
    >
      {props.title && (
        <div className={style.header}>
          <h2 className={style.title}>{props.title}</h2>
          {props.extraActions}
        </div>
      )}
      {props.children}

      {props.footerNote && (
        <div className={style.footer}>
          <div className={style.note}>{props.footerNote}</div>
          {!footerStyle && (
            <div className={style.footer_btns}>
              {props.destructiveAction}
              {props.secondaryAction}
              {props.primaryAction}
            </div>
          )}
        </div>
      )}
      {footerStyle && (
        <div className={style.footer}>
          <div className={style.footer_btns}>
            {props.secondaryAction}
            {props.destructiveAction}
          </div>
          {props.primaryAction}
        </div>
      )}
      {!props.footerNote && !footerStyle && hasActions && (
        <div className={style.footer}>
          <div className={style.footer_btns}>
            {props.secondaryAction}
            {props.destructiveAction}
          </div>
          {props.primaryAction}
        </div>
      )}
    </div>
  );
};
